import React from "react";
import Modal from "../../common/Modal/Modal";

/*
    Modal used when the user has not filled out compulsory values, but is trying to generate a report
*/

function NotEnoughDataModal({ isOpen, onClose }) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={"Error Generating Report"}
      showCustomContent={true}
      customContent={
        <>
          {/* Error message originated from the submit completed modal */}
          <div className="error-message">
            Your report could not be generated as you have not provided some
            compulsory (<span style={{ color: "red" }}>*</span>) data. Please
            check your form and ensure all data has been provided.
          </div>
          <div className="button-close-container">
            <button className="button-close" onClick={onClose}>
              Close
            </button>
          </div>
        </>
      }
    />
  );
}

export default NotEnoughDataModal;
